export default __webpack_public_path__ + "static/media/export.a0810e85.svg";